import React from "react";
import { IconBaseProps } from "react-icons";

export const AlphaBetSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
  >
    <path d="M13.488 20.996h-2.31L17.348 4h2.26l6.17 16.996H23.44L21.69 15.89H15.24l-1.752 5.105zm5.015-14.431h-.064l-2.602 7.57h5.256l-2.59-7.57zM1.54 20.996H0l4.113-11.33H5.62l4.113 11.33H8.176l-1.168-3.403h-4.3L1.54 20.996zm3.343-9.62h-.042l-1.735 5.046H6.61l-1.727-5.047z" />
  </svg>
);
